import React from "react";
import { Check2 } from "react-bootstrap-icons";

function SaveButton({ onClick }) {
    return (
        <div
            className="text-center footer-button w-100 d-flex align-items-center justify-content-center"
            style={{
                borderRadius: '0.375rem',
                cursor: "pointer",
                flexShrink: 0,
                backgroundColor: "rgb(224, 245, 230)"
            }}
            onClick={onClick}
        >
            <div className="d-flex align-items-center justify-content-center gap-2 text-success">
                <Check2 size={20} />
                <span className="fw-semibold">Save</span>
            </div>
        </div>
    );
}

export default SaveButton;